<template>
  <div class="side-by-side">
    <div class="badge" :class="{
      small: size === 'small',
      medium: size === 'medium',
      large: size === 'large',
      'badge-status': type === 'payable' || type === 'receivable',
      blue: type === 'blue',
      primary: type === 'primary',
      secondary: type === 'secondary',
      payable: type === 'payable',
      receivable: type === 'receivable',
      success: type === 'success',
      warning: type === 'warning',
      info: type === 'info',
      edit: type === 'edit',
      danger: type === 'danger',
      default: type === 'default',
    }">
      <i :class="classIcon"></i> <span>{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Badge",
  props: {
    title: String,
    type: String,
    size: String,
    classIcon: String,
  },
};
</script>

<style scoped>
.badge {
  margin-left: 10px;
  padding: 8px 12px;
  cursor: pointer;
  border: none;
  border-radius: 50px !important;
  font-size: 14px;
  font-weight: 400;
}

.small {
  padding: 5px 10px;
  font-size: 13px;
}

.medium {
  padding: 7px 12px !important;
  font-size: 13px;
}

.large {
  padding: 11px 16px !important;
  font-size: 14px;
}

.badge-status {
  margin-left: 0;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 99px !important;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: none;
}

.badge-status.payable {
  background: var(--badge-payable-bg);
  border-color: var(--badge-payable-border);
  color: var(--badge-payable-text);
}

.badge-status.receivable {
  background: var(--badge-receivable-bg);
  border-color: var(--badge-receivable-border);
  color: var(--badge-receivable-text);
}

.dark-theme .badge-status.payable,
.dark-theme .badge-status.receivable {
  background: transparent;
}

.blue {
  background: var(--badge-blue);
  border-color: var(--badge-blue);
  color: var(--badge-text-on-color);
}

.primary {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: var(--badge-text-on-color);
}

.secondary {
  background: var(--badge-secondary);
  border-color: var(--badge-secondary);
  color: var(--badge-text-on-color);
}

.success {
  color: var(--badge-text-on-color);
  background: var(--color-success);
  border-color: var(--color-success);
}

.info {
  color: var(--badge-text-on-color);
  border-color: var(--badge-info);
  background: var(--badge-info);
}

.edit {
  color: var(--badge-text-on-color);
  border-color: var(--badge-edit);
  background: var(--badge-edit);
}

.warning {
  color: var(--badge-text-on-color);
  border-color: var(--badge-warning);
  background: var(--badge-warning);
}

.danger {
  color: var(--badge-text-on-color);
  border-color: var(--badge-danger);
  background: var(--badge-danger);
}

.default {
  color: var(--text-primary);
  border-color: var(--border-subtle);
  background: var(--bg-elevated);
}
</style>
